<template>

 <section class="banner-section">
      <div class="container">
        <blockquote>
          <h1>{{data.title}}</h1>
          <span>- {{data.subtitle}} -</span>
        </blockquote>
      </div>
    </section>
</template>

<script>
export default {
  name: 'Banner',
  props: {
    data: Object
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
